import { takeEvery } from 'redux-saga'
import { take, put, call } from 'redux-saga/effects';
import _get from 'lodash.get'

export default(apiCall, types) => {
  const attemptType = types[0];
  const successType = types[1];
  const failureType = types[2];

  function * worker ({ payload, options }) {
    try {
      const response = yield call(apiCall, payload);
      yield put({ type: successType, result: _get(response, ['body']), ...options });
    } catch (error) {
      console.log({ error });
      yield put({ type: failureType, error: error });
    }
  }

  function * watcher () {
    while (true) {
      yield call(worker, yield take(attemptType));
    }
  }

  function * parallelWatcher () {
    yield * takeEvery(attemptType, worker);
  }

  return { watcher, parallelWatcher, worker };
}



// WEBPACK FOOTER //
// ./src/redux/APISaga.js